<template>
	<div class="well well-sm">
		<div class="input-group">
			<div class="form-control no-padding" :class="dropdownStatus">
				<input
					@focusin="toogleDropdown('in')"
					@focusout="toogleDropdown('out')"
					:placeholder="value || 'Pesquisar...'"
					type="text"
					v-model="search"
				/>
				<ul class="dropdown-menu" v-if="pacients.length > 0">
					<li
						v-for="(pacient, index) in pacients"
						:key="index"
						:title="`${pacient.mat} - ${pacient.nome}`"
						@click="selected(pacient.mat)"
					>
						<a href="#">{{ pacient.nome }}</a>
					</li>
				</ul>
			</div>
			<span class="input-group-btn">
				<button
					@click="$emit('openMdCreatePatient')"
					class="btn btn-primary"
				>
					<i class="fa fa-plus"></i>
				</button>
			</span>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	export default {
		props: ['value'],
		data() {
			return {
				dropdownStatus: '',
				pacients: [],
				search: '',
			};
		},
		watch: {
			search: function (val) {
				this.updateList(val);
			},
		},
		methods: {
			updateList(val) {
				if (val != '') {
					WBS.send(
						'protected-read-listPatientssd2000',
						{ search: val },
						(resp) => {
							if (resp.data == undefined) {
								this.pacients = [];
							} else {
								this.pacients = resp.data;
							}
						}
					);
				} else {
					this.pacients = [];
				}
			},
			toogleDropdown(val) {
				if (val == 'in') {
					this.pacients = [];
					this.dropdownStatus = 'open';
				}
				// else setTimeout( r=> this.dropdownStatus = '', 100)
			},
			selected(val) {
				this.$emit('input', val);
				this.pacients = '';
				this.search = '';
			},
		},
	};
</script>
<style scoped>
	.dropdown-menu a {
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.dropdown-menu {
		width: calc(100% + 2px);
		border-radius: 0px;
		margin: 0px -1px;
		border-color: #d2d6de;
		padding: 0;
		max-height: 300px;
		overflow: auto;
	}
	.form-control input {
		border: none;
		width: 100%;
		margin: 0px;
		padding: 6px 12px;
	}
	.form-control input:focus {
		outline: 1px blue;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdCreateSolicitation/components/select-patient.vue